import {
    extractAndParseJsonFromBox,
    parseOutputMarkdown,
    parseTaskKeyIsKv,
    fileStatusChange,
    getOrgImageKeys,
    pollingRefreshFileInfo
} from "@/components/file_process_js/utils";
import store from "@/store";
import {commitFileLLMAnalyseTask} from "@/api/file_llm_analyse";

import {PROMPT_CONFIG} from "@/url_config"


function fileLabelParseMDWarp(labelToParamConfig) {
    async function fileLabelParseMD(fileInfo) {
        console.log("fileLabelParseMDWarp start", fileInfo);
        initLabelResult(fileInfo)
        await analyseLabelTaskV2(fileInfo, labelToParamConfig)
        applyLabelResult(fileInfo)
        // await fileInfo.ManuResProcessor(false)
        makeAIComment(fileInfo)
        await store.dispatch("fileCheckListLevelChange")
    }

    return fileLabelParseMD
}


async function analyseLabelTask(fileInfo, labelToParamConfig) {
    if (fileInfo.status_code >= 399 || fileInfo.status_code < 0) {
        return
    }
    console.log("analyseLabelTask", fileInfo, labelToParamConfig);

    if (!fileInfo.file_image_keys.length) {
        console.log("no fileInfo.file_image_keys.length", fileInfo);
        return
    }

    const tasks = []
    fileInfo.labels.forEach(label => {
        const prompt = labelToParamConfig[label].prompt
        // console.log("fileInfo task prompt", fileInfo, prompt, labelToParamConfig)
        tasks.push({
            "prompt": {"user": prompt},
            "task_key": label,
            "split": label.includes("SPEC")
        });
    })

    const orgImageKeys = getOrgImageKeys(fileInfo)
    fileStatusChange(fileInfo, "标签内任务解析中")
    // console.log(" commitFileLLMAnalyseTask fileInfo", fileInfo, fileInfo["file_image_keys"])
    const noStructText = fileInfo.text_content
    try {
        await commitFileLLMAnalyseTask(
            fileInfo.id,
            fileInfo.file_key,
            fileInfo.root_key,
            fileInfo.file_hash,
            orgImageKeys,
            fileInfo.project_id,
            noStructText,
            tasks,
            fileInfo.status_code,
            "analyse"
        )
    } catch (e) {
        fileStatusChange(fileInfo, "执行标签任务失败", -399)
    }
    if (fileInfo.status_code < 0) {
        return
    }
    await pollingRefreshFileInfo(fileInfo, breakFunction, callbackLabelParseWarp(fileInfo), 50, 5000);
}


async function analyseLabelTaskV2(fileInfo, labelToParamConfig) {
    console.log("analyseLabelTask", fileInfo, labelToParamConfig);
    if (fileInfo.status_code >= 399 || fileInfo.status_code < 0) {
        return
    }

    if (!fileInfo.file_vision.length) {
        console.log("no fileInfo.file_image_keys.length", fileInfo);
        return
    }

    const v2 = PROMPT_CONFIG.prompt_version >= 2.0
    const tasks = []
    const noStructText = fileInfo.text_content
    for (let i = 0; i < fileInfo.file_vision.length; i++) {
        const vision_data = fileInfo.file_vision[i]
        if (!vision_data.labels) {
            console.log("analyseLabelTaskV2 fileInfo file_vision no label", fileInfo, i)
            continue
        }
        const img_key = vision_data.img_key
        if (!img_key) {
            console.error(`No img_key found for ${fileInfo.path}`)
            continue
        }
        vision_data.labels.forEach(label => {
            // v2版本优先使用v2提示词，但是对于非kv结构，还是使用v1提示词
            const prompt = v2 ? labelToParamConfig[label]["prompt_v2"] || labelToParamConfig[label]["prompt"] : labelToParamConfig[label]["prompt"]
            // console.log("fileInfo task prompt", fileInfo, label, prompt, labelToParamConfig)
            const engine = labelToParamConfig[label]["engine"] || "gemini_flash"
            tasks.push({
                "prompt": {"user": prompt},
                "task_key": label,
                // v2.0版本后，split参数无意义，都是单图传递
                "split": true,
                "image_keys": [img_key],
                "no_struct_text": noStructText[i],
                "engine": engine
            });
        })
    }

    if (!tasks.length) {
        fileStatusChange(fileInfo, "无解析标签", -399)
        return
    }

    fileStatusChange(fileInfo, "标签内任务解析中")
    console.log(" commitFileLLMAnalyseTask fileInfo", fileInfo, fileInfo["file_image_keys"])
    const orgImageKeys = getOrgImageKeys(fileInfo)
    try {
        await commitFileLLMAnalyseTask(
            {
                file_id: fileInfo.id,
                fileKey: fileInfo.file_key,
                rootKey: fileInfo.root_key,
                fileHash: fileInfo.file_hash,
                imageKeys: orgImageKeys,
                projectId: fileInfo.project_id,
                noStructText: noStructText,
                tasks: tasks,
                status_code: fileInfo.status_code,
                analyse_type: "analyse"
            }
        )
    } catch (e) {
        fileStatusChange(fileInfo, "执行标签任务失败", -399)
        return
    }
    await pollingRefreshFileInfo(fileInfo, breakFunction, callbackLabelParseWarp(fileInfo), 50, 5000);
}


function breakFunction(remoteFileInfo) {
    return remoteFileInfo.status_code < 0 || remoteFileInfo.status_code > 350
}

function updateAnalysedFileInfo(fileInfo, remoteFileInfo) {
    const syncAttrs = ["file_analyse_log", "status_code", "status"]
    syncAttrs.forEach(attr => {
        fileInfo[attr] = remoteFileInfo[attr]
    })
}


function callbackLabelParseWarp(fileInfo) {
    return (remoteFileInfo) => {
        updateAnalysedFileInfo(fileInfo, remoteFileInfo)
        // console.log("callbackLabelParseWarp fileInfo", remoteFileInfo, fileInfo);
    }
}

function parseTaskImageInfo(fileInfo, logItem) {
    const imageKey = logItem.prompt[0]["image_keys"][0]
    let imageIndex = 0
    let ratio = 1

    for (let i = 0; i < fileInfo.file_vision.length; i++) {
        const visionItem = fileInfo.file_vision[i]
        if (visionItem.img_key === imageKey) {
            imageIndex = i
            ratio = visionItem.ratio ? visionItem.ratio : 1
        }
    }
    return {imageKey, imageIndex, ratio}
}

function setResImageInfo(resObj, imageInfo) {
    const {imageKey, imageIndex, ratio} = imageInfo
    resObj["imageKey"] = imageKey
    resObj["imageIndex"] = imageIndex
    resObj["ratio"] = ratio
}

function applyLabelResult(fileInfo) {

    const v2 = PROMPT_CONFIG.prompt_version >= 2.0
    const allLabelRes = []

    fileInfo.file_analyse_log.forEach(logItem => {
        const taskIsKv = parseTaskKeyIsKv(logItem.task_key)
        // console.log("applyLabelResult logItem", logItem)
        if (logItem.status && logItem.status === "COMPLETED" && logItem.llm_response) {
            const imageInfo = parseTaskImageInfo(fileInfo, logItem)

            let perLabelRes
            if (v2 && taskIsKv) {
                perLabelRes = parseOutputMarkdown(logItem.llm_response)
            } else {
                perLabelRes = extractAndParseJsonFromBox(logItem.llm_response)
            }
            if (perLabelRes) {
                for (const key of Object.keys(perLabelRes)) {
                    const resItem = perLabelRes[key]
                    setResImageInfo(resItem, imageInfo)
                }
            }
            allLabelRes.push(perLabelRes)
        }
    })

    // console.log("applyLabelResult", allLabelRes)

    allLabelRes.forEach(perLabelRes => {
        for (let paramKeyword in perLabelRes) {
            const targetParam = fileInfo['paramsMap'][paramKeyword]
            if (!targetParam) {
                console.warn("unexpect paramKeyword", targetParam, paramKeyword)
                continue
            }
            // console.log("applyLabelResult add paramKeyword", paramKeyword, perLabelRes)
            paramAddRes(targetParam, perLabelRes[paramKeyword], fileInfo.boxProcessor)
        }
    })
}


function checkResNotNone(paramType, resObj) {
    const value = resObj.value
    const min = resObj.min
    const max = resObj.max
    const sourceText = resObj.sourceText

    if (paramType !== "table" && paramType !== "text") {
        return sourceText || value || min || max
    }
    return true
}

function paramAddRes(targetParam, resObj, boxProcessor) {
    const notNone = checkResNotNone(targetParam.type, resObj)
    if (!notNone) {
        return
    }
    const value = resObj.value
    // 将单位改为小写，适配后续映射计算
    const unit = typeof (resObj.unit) === "string" ? resObj.unit.toLowerCase() : resObj.unit
    const min = resObj.min
    const max = resObj.max
    const sourceText = resObj.sourceText
    const ratio = resObj.ratio
    const imageKey = resObj.imageKey
    const imageIndex = resObj.imageIndex
    switch (targetParam.type) {
        case "int":
            if (targetParam.res.length) return
            targetParam.res.push({
                "unit": unit,
                "value": value,
                "keyword": targetParam.keyword,
                "type": targetParam.type,
                "sourceText": sourceText,
                "boxes": boxProcessor ? boxProcessor.findAndAggregateBoxes(sourceText) : [],
                ratio,
                imageKey,
                imageIndex
            })
            break
        case "range":
            if (targetParam.res.length) return
            targetParam.res.push({
                "unit": unit,
                "min": min,
                "max": max,
                "keyword": targetParam.keyword,
                "type": targetParam.type,
                "sourceText": sourceText,
                "boxes": boxProcessor ? boxProcessor.findAndAggregateBoxes(sourceText) : [],
                ratio,
                imageKey,
                imageIndex
            })
            break
        case "str":
        case "enumeration":
            if (targetParam.res.length) return
            targetParam.res.push({
                "value": value,
                "keyword": targetParam.keyword,
                "type": targetParam.type,
                "sourceText": sourceText,
                "boxes": boxProcessor ? boxProcessor.findAndAggregateBoxes(sourceText) : [],
                ratio,
                imageKey,
                imageIndex
            })
            break
        case "text":
            if (!(resObj instanceof Array)) {
                console.error("unexpect text res", targetParam, resObj)
                break
            }
            resObj.forEach((item, index) => {
                targetParam.res.push({
                    "value": item.value,
                    "keyword": targetParam.keyword,
                    "type": targetParam.type,
                    "sourceText": item.sourceText,
                    "boxes": boxProcessor ? boxProcessor.findAndAggregateBoxes(item.sourceText) : [],
                    ratio,
                    imageKey,
                    imageIndex
                })
            })

            break
        case "table":
            // if (targetParam.res.length) return

            const fields = targetParam.fields
            if (!resObj instanceof Array) {
                console.error("unexpect table res", targetParam, resObj)
                break
            }
            const allResTable = []
            resObj.forEach((item, index) => {
                const tempRow = {}
                fields.forEach(field => {
                    tempRow[field] = item[field]
                    tempRow["sourceText"] = item["sourceText"]
                    tempRow["boxes"] = boxProcessor ? boxProcessor.findAndAggregateBoxes(item["sourceText"]) : []
                })
                allResTable.push(tempRow)
            })
            targetParam.res.push(allResTable)
            break
        default:
            console.error("unexpect type", targetParam.type)
    }
}


function initParamItem(fileInfo, allParamsMap, labelToParamConfig, label) {
    const labelConfigItem = labelToParamConfig[label];
    if (!labelConfigItem) {
        console.error("unexpect label", label)
        return
    }
    // 区分不同展示位置的label，便于后续渲染
    const labelPosition = labelConfigItem['position']
    if (!fileInfo.position_keys[labelPosition].includes(label)) {
        fileInfo.position_keys[labelPosition].push(label)
    }

    const paramKeys = labelConfigItem['params']
    paramKeys.forEach(paramKey => {
        const targetParam = allParamsMap[paramKey]

        if (!targetParam) {
            console.error("unexpect paramKey", paramKey)
            return
        }
        const copiedParamTemplate = {...targetParam};
        copiedParamTemplate['position'] = labelConfigItem['position']
        copiedParamTemplate["parsed"] = false
        copiedParamTemplate["res"] = []
        if (fileInfo['paramsMap'][paramKey]) {
            return
        }
        fileInfo['paramsMap'][paramKey] = copiedParamTemplate
        switch (targetParam.type) {
            case "int":
            case "range":
            case "str":
            case "enumeration":
                fileInfo.position_params[labelPosition].kvParams.push(copiedParamTemplate)
                break
            case "text":
                fileInfo.position_params[labelPosition].textParams.push(copiedParamTemplate)
                break
            case "table":
                fileInfo.position_params[labelPosition].tableParams.push(copiedParamTemplate)
                break
            default:
                console.error("unexpect type", targetParam.type, targetParam)
        }
    })
}


function initLabelResult(fileInfo) {
    const mainConfig = store.state.mainConfig
    const labelToParamConfig = mainConfig.label_to_param_config
    const allParamsMap = mainConfig.params_map
    fileInfo.labels.forEach(label => {
        initParamItem(fileInfo, allParamsMap, labelToParamConfig, label)

    })
    // console.log("调试信息 label labelConfigItem fileInfo", JSON.stringify(fileInfo))
}

function applyManuRes(targetParam, resObj) {
    const notNone = checkResNotNone(targetParam.type, resObj)

    if (!notNone) {
        return
    }

    const value = resObj.value
    const is_deleted = resObj.is_deleted

    if (targetParam.type === "text") {
        const newTextList = []
        targetParam.res.forEach(textRes => {
            if (textRes.value === value && is_deleted) {
                // 删除text操作 则不添加
            } else {
                newTextList.push(textRes)
            }
        })
        if (!is_deleted) {
            newTextList.push(resObj)
        }
        targetParam.res = newTextList
    } else {
        if (is_deleted) {
            targetParam.res = []
        } else {
            targetParam.res = [resObj]
        }
    }
}

function makeAIComment(fileInfo) {
    const AIRes = []
    for (const keyword of Object.keys(fileInfo.paramsMap)) {
        const targetParam = fileInfo.paramsMap[keyword]
        if (targetParam.res && targetParam.res.length > 0) {
            if (targetParam.type === "text") {
                targetParam.res.forEach(textRes => {
                    AIRes.push({
                        "comment_value": textRes,
                    })
                })
            } else if (targetParam.type === "table") {
                // 暂不添加
            } else {
                AIRes.push({
                    "comment_value": targetParam.res[0],
                })
            }
        }
    }
    console.log("makeAIComment", AIRes)
    fileInfo.AIRes = AIRes
}

function resetFileParamRes(fileInfo) {
    const paramMap = fileInfo['paramsMap']
    for (const keyword of Object.keys(paramMap)) {
        paramMap[keyword].res = []
    }
}

function setParamManuResMD(fileInfo) {
    const mainConfig = store.state.mainConfig
    const labelToParamConfig = mainConfig.label_to_param_config
    const allParamsMap = mainConfig.params_map

    async function ManuResHandler(checkListLevelChange = true) {
        resetFileParamRes(fileInfo)
        for (let i = 0; i < fileInfo.ManuRes.length; i++) {
            const manuRes = fileInfo.ManuRes[i].comment_value
            if (!manuRes) {
                continue
            }
            const label = manuRes['label']
            const paramKey = manuRes['keyword']

            if (!label || !paramKey) {
                continue
            }
            let targetParam = fileInfo['paramsMap'][paramKey]
            if (!targetParam) {
                initParamItem(fileInfo, allParamsMap, labelToParamConfig, label)
                targetParam = fileInfo['paramsMap'][paramKey]
            }
            // console.log("ManuResHandler", paramKey, fileInfo, fileInfo['paramsMap'][paramKey], manuRes)
            applyManuRes(targetParam, manuRes)
        }
        await store.dispatch("fileCheckListLevelChange")
    }

    fileInfo.ManuResProcessor = ManuResHandler
}

export function getLabelParseMD(fileInfo) {
    const mainConfig = store.state.mainConfig
    const labelToParamConfig = mainConfig.label_to_param_config
    setParamManuResMD(fileInfo) // 提前注入回调函数， 应对协同操作先加载， ai结果后加载的情况
    return fileLabelParseMDWarp(labelToParamConfig);
}